// Entrypoint for the application
import Rails from "@rails/ujs"
import "@hotwired/turbo"
import * as ActiveStorage from "@rails/activestorage"
import "../channels"
import $ from "jquery"
import "select2/dist/css/select2.min.css"
import * as bootstrap from "bootstrap"

// Import stylesheets
import "../stylesheets/application.scss"

// Make jQuery available globally for select2 and other libraries
window.$ = window.jQuery = $

if (!window._rails_loaded) {
  Rails.start()
}
ActiveStorage.start()

const initializeSelect2 = async () => {
  const module = await import("select2")
  const select2 = module.default || module
  if (typeof select2 === "function") {
    select2($)
  }
  if ($.fn.select2) {
    $("select:not([data-no-select2])").select2()
  }
}

initializeSelect2()

const onEachPageLoad = () => {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  }) 
}

const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

const initListSearch = () => {
  document.querySelectorAll('[data-action="input->list-search#submit"]').forEach((input) => {
    input.addEventListener('input', debounce(() => {
      if (input.value.length === 0 || input.value.length >= 2) {
        input.closest('form').dispatchEvent(new Event('submit', { bubbles: true }))
      }
    }, 300))
  })
}

window.addEventListener("load", onEachPageLoad)
document.addEventListener("turbo:load", () => {
  onEachPageLoad()
  initializeSelect2()
  initListSearch()
})
